// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { WEIGHT_STEPS } from '@/components/GameWeightControl';

export const DEFAULT_GAME_WEIGHT_PERCENT = 100;

const MAX_WEIGHT_PERCENT = Math.max(...WEIGHT_STEPS);

/** Clamps a game's stored/default weight into the whole-percent range the weight chip can show. */
export function normalizeWeight(value: number | null | undefined): number {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return DEFAULT_GAME_WEIGHT_PERCENT;
  }
  return Math.max(0, Math.min(MAX_WEIGHT_PERCENT, Math.round(value)));
}

/**
 * Next weight in the WEIGHT_STEPS rotation. Values outside the ladder (e.g. a weight
 * saved before the steps changed) restart the rotation from 100%.
 */
export function cycleWeightPercent(current: number): number {
  const steps = WEIGHT_STEPS as readonly number[];
  const normalized = steps.includes(current) ? current : DEFAULT_GAME_WEIGHT_PERCENT;
  const nextIndex = (steps.indexOf(normalized) + 1) % steps.length;
  return steps[nextIndex];
}
